import { render } from "./thumbtackrating.vue?vue&type=template&id=89261f44"
import script from "./thumbtackrating.js?vue&type=script&lang=js"
export * from "./thumbtackrating.js?vue&type=script&lang=js"

import "./thumbtackrating.vue?vue&type=style&index=0&id=89261f44&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__